import * as React from 'react';

import './index.less';

const icon = 'https://s1-static.msstatic.com/gamecenter/images/head-default.png'

function VideoBox(props: any) {
  const { gameBaseInfo } = props;
  const { mediaInfo, gameVideoScreenshot } = gameBaseInfo || {};
  const srcUrl: any = (mediaInfo.items.value || []).filter((el: any) => el.type == 2 || el.type == 1)[0];
  return (
    <div className='video-w'>
      {srcUrl ? (
        <video
          autoPlay={true}
          controls={!!srcUrl?.key1 || !!srcUrl?.value}
          loop={false}
          muted={true}
          controlsList='nodownload'
          poster={srcUrl?.img || gameVideoScreenshot || icon}
          // className={`${!!mediaInfo.items.value[0]?.value ? '': 'active'}`}
          src={srcUrl?.type == 2 ? srcUrl?.key1 : srcUrl?.value}
          playsInline
          webkit-playsinline="true"
          x5-playsinline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="false"></video>
      ) : (
        <img src={gameVideoScreenshot || icon} alt='' />
      )}
    </div>
  );
}

export default VideoBox;
